const financesPhilanthropySteps = [
  {
    id: 2,
    area: 'Finances & Philanthropy',
    stepTitle: 'Finances & Philanthropy Pre-Workshop Assessment',
    stepDescription: '',
    preWorkshop: true,
    questions: [
      {
        id: 1,
        title: "What is net worth?",
        options: [
          'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).',
          'What you are worth intellectually once you combine your degrees and work experience.',
          'What you are worth socially once you combine your social media followers and personal contacts.'
        ],
        correctAnswer: 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).'
      },
      {
        id: 2,
        title: "What is the Black-White wealth gap?",
        options: [
          'The major difference in Black and White people’s assets and net worth regardless of where they live due to centuries of economic oppression.',
          'The major difference in Black and White people’s experiences regardless of where they live due to centuries of economic oppression.',
          'The major difference in Black and White people’s education levels regardless of where they live due to centuries of economic oppression.'
        ],
        correctAnswer: 'The major difference in Black and White people’s assets and net worth regardless of where they live due to centuries of economic oppression.'
      },
      {
        id: 3,
        title: "What is one of the top reasons why Black people are unable to save?",
        options: [
          'They use their savings to support their family members financially.',
          'They use their savings to support their alma maters financially.',
          'They use their savings to support their churches financially.'
        ],
        correctAnswer: 'They use their savings to support their family members financially.'
      },
      {
        id: 4,
        title: "What percentage of Black parents expect to be supported by their children?",
        options: ['80%', '20%', '50%'],
        correctAnswer: '80%'
      },
      {
        id: 5,
        title: "What is generational wealth?",
        options: [
          'Financial assets passed on by one generation of a family to another.',
          'Genetic assets passed on by one generation of a family to another.',
          'Biological assets passed on by one generation of a family to another.'
        ],
        correctAnswer: 'Financial assets passed on by one generation of a family to another.'
      },
      {
        id: 6,
        title: "Do you currently know the status of where you are on the spectrum of building wealth and initiating the wealth-building process?",
        options: ['Yes', 'No'],
        correctAnswer: 'Yes'
      },
      {
        id: 7,
        title: "Why is it important to at least pay the minimums of credit cards?",
        options: [
          'So that I can maintain a good credit score.',
          'So that I can spend more money.',
          'So that I can increase my savings.'
        ],
        correctAnswer: 'So that I can maintain a good credit score.'
      },
      {
        id: 8,
        title: "What is a credit score?",
        options: [
          'The number—based on your credit history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.',
          'The number—based on your saving history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.',
          'The number—based on your investment history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.'
        ],
        correctAnswer: 'The number—based on your credit history, ranging from 300 (low) - 850 (high)—lenders use to determine the likelihood of being repaid on time if they give you a loan or a credit card.'
      },
      {
        id: 9,
        title: "How does a good or better credit score help you build wealth?",
        options: [
          'It makes it possible to borrow money from lenders for expensive but profitable investments.',
          'It makes it possible to pay back lenders for expensive but profitable investments.',
          'It makes it possible to invest in expensive but profitable investments.'
        ],
        correctAnswer: 'It makes it possible to borrow money from lenders for expensive but profitable investments.'
      },
      {
        id: 10,
        title: "What does getting out of debt require?",
        options: [
          'Sacrifice, discipline and a plan.',
          'Hope, a positive outlook and the right attitude.',
          'Skepticism, research skills and business savvy.'
        ],
        correctAnswer: 'Sacrifice, discipline and a plan.'
      },
      {
        id: 11,
        title: "What is the first step in building wealth?",
        options: ['Paying off debt', 'Saving', 'Investing'],
        correctAnswer: 'Paying off debt'
      },
      {
        id: 12,
        title: "What is philanthropic giving?",
        options: [
          'Giving time or money to a cause that furthers the good of society.',
          'Giving time or money to a corporation that employs you.',
          'Giving time or money to a political candidate who promises to improve society.'
        ],
        correctAnswer: 'Giving time or money to a cause that furthers the good of society.'
      },
      {
        id: 13,
        title: "Do you understand the root causes of Black wealth disparity?",
        options: ['Yes', 'No'],
        correctAnswer: 'Yes'
      },
      {
        id: 14,
        title: "How do you currently feel about global Black disparity? Check all that apply.",
        options: [
          'I am committed to developing solutions to the problem.',
          'I am committed to building wealth for future generations in my family and community.',
          'I am committed to learning more about related aspects of my history.'
        ],
        correctAnswer: 'I am committed to developing solutions to the problem.'
      },
      {
        id: 15,
        title: "Do you feel confident about initiating your wealth-building process?",
        options: ['Yes', 'No'],
        correctAnswer: 'Yes'
      },
      {
        id: 16,
        title: "What are your current financial habits? Check all that apply.",
        options: [
          'I pay at least the minimum of my debt on time.',
          'I save more than I spend.',
          'I follow a long-term financial plan.',
          'I give my time and/or money to Black-led, Black benefitting causes.'
        ],
        correctAnswer: 'I pay at least the minimum of my debt on time.'
      },
      {
        id: 17,
        title: "Do you feel clear on how to build personal, generational and communal wealth through financial planning?",
        options: ['Yes', 'No'],
        correctAnswer: 'Yes'
      }
    ],
    nextStep: 3
  },
      {
        id: 3,
        area: 'Finances & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'The Economic Realities Future Black Wealth Builders Face ',
        stepDescription: `In the journey towards economic empowerment, Black future wealth builders face a unique set of challenges. Systemic barriers, wealth gaps, and even unconscious biases can create roadblocks on the path to financial success. But fear not, this isn't a dead end. This is an opportunity to explore the economic realities Black entrepreneurs and investors like yourselves will encounter, so you are equipped and equip ourselves with the knowledge and strategies to break through those barriers and build generational wealth. Let's dive in! Pass and unlock Where You Stand and Your Role as a Black Wealth Builder.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 4
      },
      {
        id: 4,
        area: 'Finances & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'Where You Stand and Your Role as a Black Wealth Builder ',
        stepDescription: `Financial freedom shouldn't just be a dream; it’s a necessity! The dream of financial freedom isn't just a dream; it's a necessity. In this video, we'll dive deep into the current state of Black wealth globally, and in America. We'll explore the challenges faced by the Black community–all while empowering ,but more importantly, we'll empower YOU to take action.
          <br /><br />Whether you're just starting your financial journey or looking to level up, this video is your roadmap to building generational wealth. Let's break down the barriers, unpack the strategies, and claim your rightful place as a Black wealth builder. Pass and unlock the Discussion Regarding Generational Wealth.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 5
      },
      {
        id: 5,
        area: 'Finances & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'Where You Stand and Your Role as a Black Wealth Builder ',
        stepDescription: `Ever wondered why some families seem to have a financial head start? In this discussion, we delve into the concept of generational wealth, exploring its impact and strategies for building it. Pass and unlock the Overview of How to Build Generational Wealth.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 6
      },
      {
        id: 6,
        area: 'Finances & Philanthropy',
        videoUrl: 'https://example.com/video1.mp4',
        stepTitle: 'An Overview of How to Build Generational Wealth',
        stepDescription: `In this video, we'll crack the code on building generational wealth. We'll break down the clear steps you can take to secure your financial future and set your loved ones up for success. From budgeting basics to investment strategies, this video will equip you with the knowledge and tools to build a lasting financial foundation for generations to come. Let's dive in!  Pass and unlock the 3-Year Financial Plan for Generational Wealth & Philanthropy.`,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "What is net worth?", options: ['What you are worth socially once you combine your social media followers and personal contacts.', 'What you are worth financially once you combine what you own (your assets) and what you owe (your liabilities).', 'What you are worth intellectually once you combine your degrees and work experience.'], correctAnswer: 'What you are worth intellectually once you combine your degrees and work experience.' },
          { id: 2, title: "Test Quest2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'B' },
          { id: 3, title: "Question 2", options: ['A', 'B', 'C', 'D'], correctAnswer: 'A' },
          { id: 4, title: "Question 3", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
          { id: 5, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        nextStep: 7
      },
      {
        id: 7,
        area: 'Finances & Philanthropy',
        videoUrl: '',
        stepTitle: '3-Year Financial Plan for Generational Wealth & Philanthropy',
        stepDescription: ``,
        preWorkshop: false, // Adding the preWorkshop property
        questions: [
          { id: 1, title: "Question 4", options: ['A', 'B', 'C', 'D'], correctAnswer: 'D' },
    
        ],
        //
        nextStep: 21
      }
  ];
  
  export default financesPhilanthropySteps;
  